module.exports = __webpack_public_path__ + "img/logo-chu-grenoble.a04cf6e.webp";